import { useState, useEffect } from 'react';

type SearchSuggestion = string;

// Example mock data - replace with your actual data source or API call
const mockData: SearchSuggestion[] = [
    'happy',
    'sad',
    'angry',
    'excited',
    'bored',
];

export const useSearch = (
    apiUrl: string,
    searchTerm: string,
    debounceMs: number = 300,
) => {
    const [debouncedTerm, setDebouncedTerm] = useState<string>(searchTerm);
    const [suggestions, setSuggestions] = useState<SearchSuggestion[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedTerm(searchTerm);
        }, debounceMs);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm, debounceMs]);

    useEffect(() => {
        if (!debouncedTerm.trim()) {
            setSuggestions([]);
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        const fetchSuggestions = async () => {

            const isLocal = process.env.NODE_ENV === 'development' ? 'https://dev.missionaustralia.com.au/' : '';


            try {
                const response = await fetch(`${isLocal}${apiUrl}?count=5&term=${encodeURIComponent(debouncedTerm)}`);
                if (!response.ok) {
                    setSuggestions([]);
                    setIsLoading(false);
                    return;
                }
                const data = await response.json();
                // Assume the API returns an array of suggestions as strings
                const filteredSuggestions: SearchSuggestion[] = Array.isArray(data) ? data : [];
                setSuggestions(filteredSuggestions);
            } catch (error) {
                setSuggestions([]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchSuggestions();
    }, [debouncedTerm]);

    return { suggestions, isLoading };
};
